import styled from '@emotion/styled';
import { bodyB } from '@teamsparta/stack-font';
import { vars } from '@teamsparta/stack-tokens';

const backgroundImages = {
  sm: '/images/campaign/campaign_title_sm.svg',
  md: '/images/campaign/campaign_title_md.svg',
  lg: '/images/campaign/campaign_title_lg.svg',
} as const;

const backgroundSizes = {
  sm: { width: '197px', height: '41px' },
  md: { width: '214px', height: '41px' },
  lg: { width: '214px', height: '41px' },
} as const;

interface WrapperProps {
  titleBackground: 'sm' | 'md' | 'lg';
}

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url(${({ titleBackground }) =>
    backgroundImages[titleBackground]});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  width: ${({ titleBackground }) => backgroundSizes[titleBackground].width};
  height: ${({ titleBackground }) => backgroundSizes[titleBackground].height};
  flex-shrink: 0;
  text-align: center;
`;

export const Text = styled.span`
  ${bodyB};
  color: ${vars.neutral[0]};
`;
